export default __webpack_public_path__ + "static/media/horizontal_ray.de8e7f20.svg";